<template>
  <span>Please wait while you are logged out...</span>
</template>

<script>
export default {
  name: 'Logout',
  beforeMount () {
    this.$store.dispatch('logout')
    this.$router.push('/')
  }
}
</script>

<style>
</style>
